import React, { useState, useEffect } from 'react';
import {
  useNavigate
} from "react-router-dom";
import PropTypes from 'prop-types';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner
} from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

import { 
  HiPencilAlt
} from "react-icons/hi";

import useUser from '../hooks/useUser';
import CreateInvoiceAction from '../actions/CreateInvoiceAction';

import '../App.css';

export default function InvoiceForm() {
  const { user, setUser } = useUser();
  const navigate = useNavigate();  

  // Input states
  const [ro_number, setRoNumber] = useState();
  const [amount, setAmount] = useState();
  const [customer_phone, setCell] = useState();
  const [customer_email, setEmail] = useState();
  const [vehicle, setVehicle] = useState();
  const [notes, setNotes] = useState();

  // Loading states
  const [showRoSpinner, setShowRoSpinner] = useState(false);
  const [showCreateSpinner, setShowCreateSpinner] = useState(false);

  // Error states
  const [showAlertError, setShowAlertError] = useState(false);

  // Validation
  const [amountInvalid, setAmountInvalid] = useState(false);
  const [cellInvalid, setCellInvalid] = useState(false);
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [vehicleInvalid, setVehicleInvalid] = useState(false);

  const handleValidateChange = (e) => {
    switch (e.target.name) {
      case 'amount':
        if (!e.target.value) {
          setAmountInvalid(true);
          return;
        } else {
          setAmountInvalid(false);
        }
        break;
    }
    switch (e.target.name) {
      case 'cell':
        if (!e.target.value) {
          setCellInvalid(true);
          return;
        } else {
          setCellInvalid(false);
        }
        break;
    }
    switch (e.target.name) {
      case 'email':
        if (!e.target.value) {
          setEmailInvalid(true);
          return;
        } else {
          setEmailInvalid(false);
        }
        break;
    }
    switch (e.target.name) {
      case 'vehicle':
        if (!e.target.value) {
          setVehicleInvalid(true);
          return;
        } else {
          setVehicleInvalid(false);
        }
        break;
    }
  }

// Populate RO select
  const [singleSelections, setSingleSelections] = useState([]);
  const options = [
    {id: "1", name: "RO-21253 Carolyn Wood"},
    {id: "2", name: "RO-21254 Zach Emory"},
    {id: "3", name: "RO-21255 David Brown"},
    {id: "4", name: "RO-21256 Lauren Teller"},
    {id: "5", name: "RO-21257 Eloise Hall"},
    {id: "6", name: "RO-21258 Luther Paulding"},
    {id: "1", name: "RO-21259 Tyler Downing"},
    {id: "2", name: "RO-21260 Jessica Freeman"},
  ];

  // RO Select Form Handler
  const handleSelectRoSubmit = async e => {
    setShowRoSpinner(true);
  }

  // Scratch Form Handler
  const handleCreateSubmit = async e => {
    setShowCreateSpinner(true);
    const response = await CreateInvoiceAction(user.token, {
      ro_number,
      amount,
      customer_phone,
      customer_email,
      vehicle,
      notes,
    });

    if(!!response.success) {
      navigate("/merchant/dashboard", { state: { action: "new_invoice" } });      
    } else {
      setShowAlertError(true);
    }

  }

  return (
    <Container fluid className="text-start mt-3 mt-md-5">

      <Row className="">
        <Col />
        <Col xs={12} sm={8}>
          <h5>Select an RO</h5>
        </Col>
        <Col />
      </Row>
      <Row>
        <Col />
        <Col xs={12} sm={8}>
          <Card>
            <Card.Body>
              <Form>
                <Form.Group className="mb-3" controlId="formRoSelect">
                  <Form.Label>Customer / RO Number</Form.Label>
                    <Typeahead
                      id="basic-typeahead-single"
                      labelKey="name"
                      onChange={setSingleSelections}
                      options={options}
                      placeholder="Search or select"
                      selected={singleSelections}
                    />
                </Form.Group>
                { !showRoSpinner && 
                  <Button onClick={e => handleSelectRoSubmit()} variant="primary" className="float-end">
                    Save
                  </Button>
                }
                { showRoSpinner && 
                  <Button disabled variant="primary" className="float-end">
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Saving...
                  </Button>
                }
              </Form>
            </Card.Body>
          </Card>
        </Col>
        <Col />
      </Row>
      <Row className="mt-5">
        <Col />
        <Col xs={12} sm={8}>
          <h5>Or create from scratch</h5>
        </Col>
        <Col />
      </Row>
      <Row className="">
        <Col />
        <Col xs={12} sm={8}>
          <Card>
            <Card.Body>
              { showAlertError && 
                  <Alert severity="error" icon={false} className="alert">
                    <AlertTitle>Error saving invoice</AlertTitle>
                  </Alert>
              }
              <Form>

                <Form.Group className="mb-3" controlId="formAmount">
                  <Form.Label>Amount</Form.Label>
                  <Form.Control 
                    isInvalid={amountInvalid} 
                    type="text" 
                    placeholder="Enter invoice amount" 
                    name="amount"
                    onChange={e => setAmount(e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter an amount to invoice.
                  </Form.Control.Feedback>                        
                </Form.Group>

                <Form.Group className="mb-3" controlId="formFirstName">
                  <Form.Label>RO Number</Form.Label>
                  <Form.Control 
                    type="text" 
                    placeholder="Enter RO number" 
                    name="roNumber"
                    onChange={e => setRoNumber(e.target.value)} 
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formFirstName">
                  <Form.Label>Customer Cell</Form.Label>
                  <Form.Control 
                    isInvalid={cellInvalid} 
                    type="text" 
                    placeholder="Enter customer cell number" 
                    name="cell"
                    onChange={e => setCell(e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter customer cell number
                  </Form.Control.Feedback>    
                </Form.Group>

                <Form.Group className="mb-3" controlId="formFirstName">
                  <Form.Label>Customer Email</Form.Label>
                  <Form.Control 
                    isInvalid={emailInvalid} 
                    type="text" 
                    placeholder="Enter customer email" 
                    name="email"
                    onChange={e => setEmail(e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter customer email.
                  </Form.Control.Feedback>    
                </Form.Group>

                <Form.Group className="mb-3" controlId="formFirstName">
                  <Form.Label>Vehicle</Form.Label>
                  <Form.Control 
                    isInvalid={vehicleInvalid} 
                    type="text" 
                    placeholder="Enter Year/Make/Model" 
                    name="vehicle"
                    onChange={e => setVehicle(e.target.value)} 
                    onBlur={e => handleValidateChange(e)} 
                  />
                  <Form.Control.Feedback type="invalid">
                    Please enter the vehicle year/make/model
                  </Form.Control.Feedback>    
                </Form.Group>

                <Form.Group className="mb-3" controlId="formFirstName">
                  <Form.Label>Invoice Details</Form.Label>
                  <Form.Control 
                    as="textarea" 
                    placeholder="Enter invoice line items" 
                    name="notes"
                    rows={3} 
                    onChange={e => setNotes(e.target.value)} 
                  />
                </Form.Group>
                <Button onClick={e => handleCreateSubmit()} variant="primary" className="float-end">
                  Save
                </Button>                  
              </Form>
            </Card.Body>
          </Card>
        </Col>
        <Col />
      </Row>      
    </Container>
  );
}


